// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ycfc0","right":"styles_right__wUVQT"};